import { trackerDownload, trackerGet } from '../client';
import type {
  BreakdownRow,
  ClickEvent,
  PageResult,
  StatsSummary,
  TargetDetail,
  TargetListItem,
} from '../types';

export function listTargets(params: {
  from?: string;
  to?: string;
  page?: number;
  page_size?: number;
} = {}) {
  return trackerGet<PageResult<TargetListItem>>('/targets', params);
}

export function getTargetDetail(params: {
  target_url: string;
  from?: string;
  to?: string;
  page?: number;
  page_size?: number;
}) {
  return trackerGet<TargetDetail>('/targets/detail', params);
}

export function targetSummary(params: {
  target_url: string;
  from?: string;
  to?: string;
}) {
  return trackerGet<StatsSummary>('/targets/stats/summary', params);
}

export function targetBreakdown(params: {
  target_url: string;
  from?: string;
  to?: string;
  group_by?: string;
  country?: string;
  language?: string;
  device_type?: string;
}) {
  return trackerGet<{ items: BreakdownRow[] }>('/targets/stats/breakdown', params);
}

export function targetClicks(params: {
  target_url: string;
  from?: string;
  to?: string;
  page?: number;
  page_size?: number;
  outcome?: string;
  is_bot?: number;
  country?: string;
  language?: string;
  device_type?: string;
  correlation_id?: string;
  aggregator_id?: number;
}) {
  return trackerGet<PageResult<ClickEvent>>('/targets/clicks', params);
}

export function targetClicksCsv(
  params: {
    target_url: string;
    from?: string;
    to?: string;
    outcome?: string;
    is_bot?: number;
    country?: string;
    language?: string;
    device_type?: string;
    aggregator_id?: number | string;
    variant?: 'basic' | 'full';
  },
  filename?: string,
) {
  const variant = params.variant || 'basic';
  const suffix = variant === 'basic' ? '' : `-${variant}`;
  return trackerDownload(
    '/targets/clicks/csv',
    params,
    filename || `target-clicks${suffix}.csv`,
  );
}

export function targetClicksXlsx(
  params: {
    target_url: string;
    from?: string;
    to?: string;
    outcome?: string;
    is_bot?: number;
    country?: string;
    language?: string;
    device_type?: string;
    aggregator_id?: number | string;
    variant?: 'basic' | 'full';
  },
  filename?: string,
) {
  const variant = params.variant || 'full';
  const suffix = variant === 'full' ? '' : `-${variant}`;
  return trackerDownload(
    '/targets/clicks/xlsx',
    params,
    filename || `target-clicks${suffix}.xlsx`,
  );
}
